import React from "react";
import UserBox from "./UserBox";
import LangBox from "../LangBox";
import LogoBox from "./LogoBox";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";
import DigitalWatch from "components/DigitalWatch";
import { logout } from "_actions";
import { UpdateLang } from "_actions";
import { connect } from "react-redux";
import Emitter from "_actions/emitter";
import { SiteFeatures } from "config/siteFeatures";

export const Navbar = (props) => {
  const { currentLang } = props;

  return (
    <Translation>
      {(t) => (
        <div className="base-nav mobile-hide bg-secondary-500  drop-shadow-2xl  text-base-content sticky top-0 z-30 flex w-full justify-center bg-opacity-90 backdrop-blur transition-shadow duration-100 [transform:translate3d(0,0,0)] shadow-xl bg-contain bgpattern border-b-1 border-secondary-50 border-b border-solid">
          <nav className="navbar w-full">
            <div className="flex flex-1 md:gap-1 lg:gap-2">
              <LogoBox />
            </div>
            <div className="flex-0">
              <LangBox />
              <div className="mr-2"></div>
              {
                props.loggedIn ? <UserBox /> : <div className="btn-xs	text-white btn btn-ghost bg-primary-400/50 bg-transparent uppercase" onClick={() => {
                  Emitter.emit("LOGIN_MODAL", true);
                }}>
                  {t("BUTTON_SIGNIN")}
                </div>}
              <div className="mr-2"></div>
              {false && <DigitalWatch />}
            </div>
          </nav>
          <div className="flex justify-center items-center bg-secondary-500 h-12 w-full border-b-1 border-secondary-50 border-b border-solid">

            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.SPORTS_ACCESS?.Value) && (
              <Link
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
                className=" btn btn-transparent btn-outline  border-0"
                to={"/sports"}
              >
                {t("TITLE_SPORTS")}
              </Link>
            )}


            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.CASINO_ACCESS?.Value) && (
              <Link
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
                className=" btn btn-transparent btn-outline  border-0"
                to={"/casino"}
                onClick={() => {
                  if (!(!SiteFeatures.CLOSED_SYSTEM || props.loggedIn)) {
                    Emitter.emit("LOGIN_MODAL", true);
                  }
                }}
              >
                {t("TITLE_CASINO")}
              </Link>
            )}

            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.LIVECASINO_ACCESS?.Value) && (
              <Link
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
                className=" btn btn-transparent btn-outline  border-0"
                to={"/live-casino"}
                onClick={() => {
                  if (!(!SiteFeatures.CLOSED_SYSTEM || props.loggedIn)) {
                    Emitter.emit("LOGIN_MODAL", true);
                  }
                }}
              >
                {t("TITLE_LIVECASINO")}
              </Link>
            )}
            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.GAMES_ACCESS?.Value) && (
              <Link
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
                className=" btn btn-transparent btn-outline  border-0"
                to={"/games"}
                onClick={() => {
                  if (!(!SiteFeatures.CLOSED_SYSTEM || props.loggedIn)) {
                    Emitter.emit("LOGIN_MODAL", true);
                  }
                }}
              >
                {t("TITLE_GAMES")}
              </Link>
            )}
            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.VIRTUAL_ACCESS?.Value) && (
              <Link
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
                className=" btn btn-transparent btn-outline  border-0"
                to={"/virtual"}
                onClick={() => {
                  if (!(!SiteFeatures.CLOSED_SYSTEM || props.loggedIn)) {
                    Emitter.emit("LOGIN_MODAL", true);
                  }
                }}
              >
                {t("TITLE_VIRTUAL")}
              </Link>
            )}
            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.TVGAMES_ACCESS?.Value) && (
              <Link
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
                className=" btn btn-transparent btn-outline  border-0"
                to={"/tv-games"}
                onClick={() => {
                  if (!(!SiteFeatures.CLOSED_SYSTEM || props.loggedIn)) {
                    Emitter.emit("LOGIN_MODAL", true);
                  }
                }}
              >
                {t("TITLE_TVGAMES")}
              </Link>
            )}
            {false && SiteFeatures.BONUS_SYSTEM && (
              <Link
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
                className=" btn btn-transparent btn-outline  border-0"
                to={"/bonus"}
              >
                {t("TITLE_BONUS")}
              </Link>
            )}

            <Link
              style={{
                color: "#fff",
                textDecoration: "none",
              }}
              className=" btn btn-transparent btn-outline  border-0"
              to={"/rules"}
            >
              {t("TITLE_RULES")}
            </Link>

            {
              props.loggedIn &&
              <Link
                style={{
                  color: "#fff",
                  textDecoration: "none",
                }}
                className=" btn  btn-transparent btn-outline  border-0"
                to={"/my-account/profile/"}
                onClick={() => {
                  if (!(!SiteFeatures.CLOSED_SYSTEM || props.loggedIn)) {
                    Emitter.emit("LOGIN_MODAL", true);
                  }
                }}
              >
                {t("TITLE_MYACCOUNT")}
              </Link>
            }

            {
              props.loggedIn &&
              <div
                style={{
                  textDecoration: "none",
                  background: "transparent",
                }}
                className=" btn  btn-ghost text-red-600 btn-outline  border-0"
                onClick={() => {
                  props.logout();
                }}
              >
                {t("LOGOUT")}
              </div>
            }

          </div>
        </div>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang, permissions } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    currentLang,
    permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    UpdateLang: (data) => dispatch(UpdateLang(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
